import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export function AddRowTop(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 -1 24 24" {...props}>
      <path d="M11 11h2V8h3V6h-3V3h-2v3H8v2h3v3Zm11 4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3M4 15h4v3H4v-3m6 0h4v3h-4v-3m6 0h4v3h-4v-3Z" />
    </SvgIcon>
  );
}
